const headerMenuProducts = [
    "header-menu-products-booklets", 
    "header-menu-products-brochures", 
    "header-menu-products-postcards", 
    "header-menu-products-marketing-essentials", 
    "header-menu-products-cards-invitations", 
    "header-menu-products-businesscards-stationery", 
    "header-menu-products-signs-banners-displays", 
    "header-menu-products-stickers-labels-packaging", 
    "header-menu-products-direct-mail", 
    "header-menu-products-industry", 
    "header-menu-products-promo-apparel"
]

export default headerMenuProducts;